import { NgModule } from '@angular/core';
import { SmartBannerEffects } from '@main/smart-banner/feature';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducerProvider, reducerToken } from './index';
import { SMART_BANNER_FEATURE } from './smart-banner-state';

@NgModule({
  imports: [StoreModule.forFeature(SMART_BANNER_FEATURE, reducerToken), EffectsModule.forFeature([SmartBannerEffects])],
  providers: [reducerProvider],
})
export class SmartBannerStoreModule {}
